module.exports = __webpack_public_path__ + "img/hr-transition-1.8540c7dc.png";